exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-checkbox[data-v-e3aa591e]{\n  padding-left: 20px;\n}\n", ""]);

// exports
